import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Navbar';

import './css/ContactUs.css';

function ContactUs() {


    return (

        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>

            <div>
                <h4 className="label display-6">Contact Us</h4>
                <hr />

                <dl class="row">
                    <dt class="col-sm-3"><h2>Dandenong Temple</h2></dt>
                    <dd class="col-sm-9"><p>43 Hemmings Street, Dandenong</p><p>Telephone: 03 9794 9492</p>
                    </dd>
                    <hr />
                    <dt class="col-sm-3"><h2>Cranbourne Temple</h2></dt>
                    <dd class="col-sm-9"><p>1240 Western Port Highway, Cranbourne South</p><p>Telephone: 03 9770 7027</p>
                    </dd>
                    <hr />
                    <dt class="col-sm-3"><h2>eMail Address</h2></dt>
                    <dd class="col-sm-9"><p>temple@dhammadeepa.org.au</p>
                    </dd>

                </dl>
            </div>
        </div>
    )
}
export default ContactUs;